var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilhouetteWithPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.0013C12.2999 10.0013 14.1654 8.13582 14.1654 5.83464C14.1654 3.53345 12.2999 1.66797 9.9987 1.66797C7.69751 1.66797 5.83203 3.53345 5.83203 5.83464C5.83203 8.13582 7.69751 10.0013 9.9987 10.0013Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 18.3333C2.83984 15.1083 6.04817 12.5 9.99817 12.5C10.7982 12.5 11.5732 12.6083 12.2982 12.8083",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 15.0013C18.3346 15.268 18.3013 15.5263 18.2346 15.7763C18.1596 16.1096 18.0263 16.4346 17.8513 16.718C17.2763 17.6846 16.218 18.3346 15.0013 18.3346C14.143 18.3346 13.368 18.0096 12.7846 17.4763C12.5346 17.2596 12.318 17.0013 12.1513 16.718C11.843 16.218 11.668 15.6263 11.668 15.0013C11.668 14.1013 12.0263 13.2763 12.6096 12.6763C13.218 12.0513 14.068 11.668 15.0013 11.668C15.9846 11.668 16.8763 12.093 17.4763 12.7763C18.0096 13.368 18.3346 14.1513 18.3346 15.0013Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2411 14.9805H13.7578",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.7656V16.2573",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilhouetteWithPlus);
export default __webpack_public_path__ + "static/media/silhouette-with-plus.044d51859c0bd1beb6ce6423f0067139.svg";
export { ForwardRef as ReactComponent };